import { CarriersEnum } from '@app/app.enum';

export const OnlyNumberAndLetterRegex = /^[A-Za-z0-9]*$/;
export const OnlyNumberRegex = /^[\d]+$/;
export const CustomsItemMaxDeclaredValueLimit = [0, 100000];
export const CarriersNotRequiringEmail = [CarriersEnum.USPSeVS, CarriersEnum.USPSeVSNative, CarriersEnum.USPSShip];
export const CarriersSupportingScanForm: string[] = [
	CarriersEnum.USPSeVS,
	CarriersEnum.USPSePostage,
	CarriersEnum.USPSShip,
	CarriersEnum.USPSeVSNative,
	CarriersEnum.USPSePostageNative,
	CarriersEnum.USPSPHv2,
];
export const NativeCarriers = [CarriersEnum.USPSeVSNative, CarriersEnum.USPSePostageNative, CarriersEnum.FedExNative, CarriersEnum.UPSNative];



// WEBPACK FOOTER //
// ./src/constants/carrier-account.constants.ts